import LoadingSpiner from "@/components/ui/loading-spiner";
import SupabasePool from "@/lib/supabaseClient";
import { ProjectPostProps } from "@/type/ProjectTypes";
import { useQuery } from "@tanstack/react-query";
import ListItem from "./list-item";

export default function PinnedProject() {
  const { data, isLoading } = useQuery<ProjectPostProps[]>({
    queryKey: ["project-list"],
    queryFn: async () => {
      // ... (데이터 페칭 동일)
      const { data, error } = await SupabasePool.getInstance()
        .from("project_meta")
        .select(
          `
            *,
            project_meta_stack(
                project_stack(*)
            ),
            project_pin(*)
            `
        )
        .order("id", { ascending: false });

      if (error) {
        throw new Error(
          `데이터를 불러오는 중 에러가 발생했습니다: ${error.message}`
        );
      }
      return data || [];
    },

    staleTime: Infinity,
  });

  return (
    <div className="pt-10">
      <h1 className="border-b border-zinc-500 pb-2 text-xl">고정콘텐츠 설정</h1>

      <div className=" ">
        {isLoading ? (
          <LoadingSpiner />
        ) : (
          <ul className="divide-y divide-border">
            {data?.map((e, idx) => <ListItem {...e} key={`${e.id}:${idx}`} />)}
          </ul>
        )}
      </div>
    </div>
  );
}
